<template>
  <div>
    <b-modal
      id="modal-input"
      size="xl"
      centered
      :title="$store.state.modal.tambahUser"
      header-bg-variant="primary"
      header-text-variant="light"
    >
      <b-form>
        <b-form-group :label="$store.state.form.username" label-cols-md="3">
          <b-form-input
            type="text"
            :state="checkIfValid('username')"
            v-model="$v.data.username.$model"
            v-on:keydown.enter.prevent="simpan()"
          ></b-form-input>
        </b-form-group>

        <b-form-group :label="$store.state.form.email" label-cols-md="3">
          <b-form-input
            type="email"
            :state="checkIfValid('email')"
            v-model="$v.data.email.$model"
            v-on:keydown.enter.prevent="simpan()"
          ></b-form-input>
        </b-form-group>

        <b-form-group :label="$store.state.form.nip" label-cols-md="3">
          <b-form-input
            type="text"
            :state="checkIfValid('NIP')"
            v-model="$v.data.NIP.$model"
            v-on:keydown.enter.prevent="simpan()"
          ></b-form-input>
        </b-form-group>

        <b-form-group :label="$store.state.form.nomorTelepon" label-cols-md="3">
          <b-form-input
            type="text"
            :state="checkIfValid('nomorTelepon')"
            v-model="$v.data.nomorTelepon.$model"
            v-on:keydown.enter.prevent="simpan()"
          ></b-form-input>
        </b-form-group>

        <b-form-group :label="$store.state.form.password" label-cols-md="3">
          <b-input-group>
            <b-form-input
              :type="showPassword ? 'text' : 'password'"
              :state="checkIfValid('password')"
              v-model="$v.data.password.$model"
              v-on:keydown.enter.prevent="simpan()"
            ></b-form-input>
            <b-input-group-append class="m-0">
              <b-button @click="showPassword = !showPassword">
                <b-icon :icon="showPassword ? 'eye' : 'eye-slash'" />
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>

        <b-form-group :label="$store.state.form.karyawan" label-cols-md="3">
          <Multiselect
            class="w-100"
            v-model="data.karyawan"
            :options="listKaryawan"
            :multiple="false"
            :searchable="true"
            :close-on-select="true"
            :show-labels="false"
            label="namaKaryawan"
            track-by="dataKaryawanId"
            :placeholder="$store.state.form.placeholderKaryawan"
          ></Multiselect>
        </b-form-group>

        <b-form-group :label="$store.state.form.mitra" label-cols-md="3">
          <Multiselect
            class="w-100"
            v-model="data.mitra"
            :options="listMitra"
            :multiple="false"
            :searchable="true"
            :close-on-select="true"
            :show-labels="false"
            label="namaMitra"
            track-by="id"
            :placeholder="$store.state.form.placeholderMitra"
          ></Multiselect>
        </b-form-group>
      </b-form>

      <template #modal-footer>
        <b-button variant="secondary" @click="$bvModal.hide('modal-input')">
          {{ $store.state.form.batal }}
        </b-button>
        <b-button variant="primary" :disabled="busy || !isValid" @click="simpan()">
          {{ button }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>


<script>
import { validationMixin } from "vuelidate";
import { required, email } from "vuelidate/lib/validators";
import { mapGetters } from "vuex";
export default {
  name: "modalInput",
  props: ["listMitra", "listKaryawan"],
  data() {
    return {
      data: {
        username: null,
        email: null,
        NIP: null,
        nomorTelepon: null,
        password: null,
        karyawan: null,
        mitra: null,
      },
      showPassword: false,
      busy: false,
      button: "Simpan",
    };
  },
  computed: {
    ...mapGetters(["lang"]),
    formString() {
      return JSON.stringify(this.data, null, 4);
    },
    isValid() {
      return !this.$v.data.$invalid;
    },
    isDirty() {
      return this.$v.data.$anyDirty;
    },
  },
  mixins: [validationMixin],
  validations: {
    data: {
      username: { required },
      email: { required, email },
      NIP: {},
      nomorTelepon: { required },
      password: { required },
      karyawan: {},
      mitra: {},
    },
  },
  mounted() {
    this.data.mitra = this.$store.state.mitra_aktif;
  },
  methods: {
    checkIfValid(fieldName) {
      const field = this.$v.data[fieldName];
      if (!field.$dirty) {
        return null;
      }
      return !(field.$invalid || field.$model === "");
    },
    simpan() {
      let vm = this;
      if (vm.isValid) {
        vm.busy = true;
        vm.button = this.$store.state.form.tunggu;
        vm.data.mitraId = vm.data.mitra ? vm.data.mitra.id : null;
        vm.data.dataKaryawanId = vm.data.karyawan ? vm.data.karyawan.dataKaryawanId : null;
        vm.$axios
          .post("user/register", vm.data)
          .then((res) => {
            console.log("user/register", res);
            if (res.data.message == "sukses") {
              vm.button = this.$store.state.form.simpan;
              vm.busy = false;
              vm.$emit("alertFromChild", {
                variant: "success",
                msg: "BERHASIL MENDAFTARKAN MASTER USER",
                showing: true,
              });
              this.data.namaAsuransi = "";
              this.$v.$reset();
              this.$bvModal.hide("modal-input");
            } else {
              vm.button = this.$store.state.form.simpan;
              vm.busy = false;
              vm.$emit("alertFromChild", {
                variant: "danger",
                msg: res.data.message.toUpperCase(),
                showing: true,
              });
            }
          })
          .catch((err) => {
            vm.button = this.$store.state.form.simpan;
            vm.busy = false;
            vm.$emit("alertFromChild", {
              variant: "danger",
              msg: err.message.toUpperCase(),
              showing: true,
            });
          });
      }
    },
  },
  watch: {
    lang: function (val) {
      val;
      this.button = this.$store.state.form.simpan;
    },
  },
};
</script>
